<template>
  <ApplicationHeader
    :logo="
      $q.screen.xs
        ? theme().novatedBrand?.logo?.mobile
        : theme().novatedBrand?.logo?.colour
    "
    :alert="!isProfileSetupComplete ? 1 : 0"
    :is-profile-setup-complete="isProfileSetupComplete"
    :profile-setup-complete-percentage="profileSetupCompletePercentage"
    :profile-name="$auth.user.name"
    :profile-email="$auth.user.email"
    :org-contact-email="theme().novatedBrand?.support?.email"
    :org-contact-phone="theme().novatedBrand?.support.phone"
    :is-mobile="$q.screen.xs"
    :can-clear-application="canClearApplication"
    :clearing-application="clearingApplication"
    @go:home="goHome"
    @open:profile-setup="openProfileStepper"
    @open:profile-page="openProfilePage"
    @logout="logout"
    @clear:application="clearApplication"
  />
</template>

<script>
import UserProfileStepper from '../../widgets/user-profile-stepper';
import UserProfile from '../../widgets/user-profile';
import { mapActions, mapGetters, mapState } from 'vuex';
import { getEnv } from 'ecx.saigon.ui.common';

export default {
  name: 'ApplicationHeaderWidget',
  data() {
    return {
      canClearApplication: false
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      loadingUser: (state) => state.user.loadingUser,
      clearingApplication: (state) => state.application.clearingApplication
    }),
    ...mapGetters('user', [
      'theme',
      'brandName',
      'isProfileSetupComplete',
      'profileSetupCompletePercentage'
    ])
  },
  watch: {
    loadingUser() {
      if (!this.loadingUser && !this.isProfileSetupComplete) {
        this.openProfileStepper();
      }
    }
  },
  methods: {
    ...mapActions('application', ['clearApplicationRequest']),
    logout() {
      this.$router.push({ name: this.$RouteNames.logout });
    },
    goHome() {
      if (this.$router.currentRoute.name !== this.$Constants.HOME_ROUTE) {
        this.$router.push({
          name: this.$Constants.HOME_ROUTE,
          params: { ...this.$router.currentRoute.params }
        });
      }
    },
    openProfilePage() {
      this.SAIFullScreenDialog({
        parent: this,
        child: UserProfile
      });
    },
    openProfileStepper() {
      this.SAIFullScreenDialog({
        parent: this,
        noRouteDismiss: true,
        displayHideAction: true,
        child: UserProfileStepper
      });
    },
    async clearApplication() {
      await this.clearApplicationRequest();
      if (this.$router.currentRoute.name !== this.$RouteNames.calculator) {
        await this.$router.push({ name: this.$RouteNames.calculator });
        this.$router.go(0);
      }
    }
  },
  components: {
    ApplicationHeader: () =>
      import('../../components/molecule/application-header')
  },
  async mounted() {
    const env = await getEnv();
    this.canClearApplication = env.VUE_APP_CAN_CLEAR_APPLICATION;
  }
};
</script>
